// features/ui/uiSlice.js
import { createSlice } from '@reduxjs/toolkit';

const uiSlice = createSlice({
  name: 'ui',
  initialState: {
    loadingCount: 0,
    loading: false,
  },
  reducers: {
    startLoading(state) {
      state.loadingCount += 1;
      state.loading = true;
    },
    stopLoading(state) {
      if (state.loadingCount > 0) {
        state.loadingCount -= 1;
      }
      if (state.loadingCount === 0) {
        state.loading = false;
      }
    },
  },
});

export const { startLoading, stopLoading } = uiSlice.actions;
export default uiSlice.reducer;